<button
  pButton
  [disabled]="_disabled"
  label="{{ 'app.titles.create' | translate | uppercase }}"
  class="kButtonDefault kUploadBtn"
  (click)="uploadmenu.open()"
></button>

<kPopupWidget
  #uploadmenu
  data-aid="uploadmenu"
  [popupWidth]="360"
  [popupHeight]="385"
  [closeBtn]="true"
  [modal]="true"
  [transparent]="true"
  [preventPageScroll]="true"
>
  <ng-template>
    <kKMCUploadMenu (onItemSelected)="_onMenuItemSelected($event)"></kKMCUploadMenu>
  </ng-template>
</kPopupWidget>

<kPopupWidget
  #uploadsettings
  data-aid="uploadsettings"
  [popupWidth]="791"
  [popupHeight]="607"
  [closeBtn]="true"
  [modal]="true"
  [preventPageScroll]="true"
>
  <ng-template>
    <kKMCUploadSettings [parentPopupWidget]="uploadsettings" [creationType]="_creationType"></kKMCUploadSettings>
  </ng-template>
</kPopupWidget>

<kPopupWidget
  #bulkuploadmenu
  data-aid="bulkuploadmenu"
  [popupWidth]="382"
  [popupHeight]="436"
  [closeBtn]="true"
  [modal]="true"
>
  <ng-template>
    <kKMCBulkUploadMenu (onClose)="bulkuploadmenu.close()"></kKMCBulkUploadMenu>
  </ng-template>
</kPopupWidget>

<kPrepareEntry #prepareEntry></kPrepareEntry>

<kPopupWidget #createLive data-aid="createLive" [popupWidth]="791" [popupHeight]="675" [closeBtn]="true" [modal]="true">
  <ng-template>
    <kCreateLive [parentPopupWidget]="createLive"></kCreateLive>
  </ng-template>
</kPopupWidget>

<kPopupWidget
  #createFromYoutube
  data-aid="createFromYoutube"
  [popupWidth]="791"
  [popupHeight]="357"
  [closeBtn]="true"
  [modal]="true"
>
  <ng-template>
    <kKMCUploadFromYoutube [parentPopupWidget]="createFromYoutube"></kKMCUploadFromYoutube>
  </ng-template>
</kPopupWidget>
